<template>
<section>
    <div class="wrap">

        <!-- <ul class="my_review_ul">
            <li :class="{ cho : (dtype == TABLE_TYPE.SC.id) }" @click="tab(TABLE_TYPE.SC.id)"><a>SC</a></li>
            <li :class="{ cho : (dtype == TABLE_TYPE.SHOP.id) }" @click="tab(TABLE_TYPE.SHOP.id)"><a>전시장</a></li>
            <li :class="{ cho : (dtype == TABLE_TYPE.TRIM.id) }" @click="tab(TABLE_TYPE.TRIM.id)"><a >차량</a></li>
        </ul> -->

        <div class="reservation_type_ul">
            <a :class="{ now : (dtype == TABLE_TYPE.SC.id) }" @click="tab(TABLE_TYPE.SC.id)">SC</a>
            <a :class="{ now : (dtype == TABLE_TYPE.SHOP.id) }" @click="tab(TABLE_TYPE.SHOP.id)">전시장</a>
            <a :class="{ now : (dtype == TABLE_TYPE.TRIM.id) }" @click="tab(TABLE_TYPE.TRIM.id)">차량</a>
        </div>

  
        <div class="new_content_box1"> 
            <div class="review_content_box">
                <figure :class="{ 'reviewTrimImg' : (dtype == TABLE_TYPE.TRIM.id) }">
                    <img :src="reviewImg" />
                </figure>
                <figcaption>
                    <dl v-if="dtype == TABLE_TYPE.SC.id">
                        <dt>{{ reviewTitle }} 컨설턴트</dt>

                        <dd>
                            {{ (bookingItem.shop) ? bookingItem.shop.name : ''}}
                            ({{(bookingItem.dealer) ? bookingItem.dealer.name : ''}})
                        </dd>
                        <div class="star_box2">
                        <star-rating
                            :rating="reviewRating"
                            :increment="0.5"
                            :max-rating="5"
                            :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                            inactive-color="#E9EAEC"
                            active-color="#FFE78A"
                            :star-size="15"
                            text-class = ''
                            read-only>
                        </star-rating>
                    </div>    
                    </dl>

                    <dl v-if="dtype == TABLE_TYPE.SHOP.id">

                        <dt>{{ reviewTitle }}<span>{{ (bookingItem.dealer) ? bookingItem.dealer.name : '' }}</span></dt>
                        <dd>{{ (bookingItem.shop) ? bookingItem.shop.addr : '' }}</dd>
                        <div class="star_box2">
                            <star-rating
                                :rating="reviewRating"
                                :increment="0.5"
                                :max-rating="5"
                                :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                inactive-color="#E9EAEC"
                                active-color="#FFE78A"
                                :star-size="15"
                                text-class = ''
                                read-only>
                            </star-rating>
                        </div>    
                    </dl>

                    <dl v-if="dtype == TABLE_TYPE.TRIM.id">
                        <dt>{{ reviewTitle }}</dt>
                        <dd>
                            {{ (bookingItem.model) ? bookingItem.model.name : ''}}
                            ({{ (bookingItem.brand) ? bookingItem.brand.name: ''}})
                        </dd>
                        <div class="star_box2">
                            <star-rating
                                :rating="reviewRating"
                                :increment="0.5"
                                :max-rating="5"
                                :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                inactive-color="#E9EAEC"
                                active-color="#FFE78A"
                                :star-size="15"
                                text-class = ''
                                read-only>
                            </star-rating>
                        </div>    
                    </dl>
                </figcaption>
                
            </div>
        </div>
       
    <!--
        <div class="review_evaluation_box" style="animation: opacity2 0.8s;">
            <h3 class="title" style="margin-bottom:0">
                <span>평가</span>
            </h3>
            <div class="review_evaluation">
                <div class="star_box">
                    <p>{{reviewRating}}</p>
                    <star-rating
                        :rating="reviewRating"
                        :increment="0.5"
                        :max-rating="5"
                        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                        inactive-color="#E9EAEC"
                        active-color="#FFE78A"
                        :star-size="26"
                        text-class = ''
                        read-only>
                    </star-rating>
                </div>    
                <template v-for="(important, key) in REVIEW_SCORE">
                    <input 
                        type="radio" 
                        :id="`score-${important.id}`" 
                        name="type" 
                        :key="key" 
                        :checked="checkedScore(important.id)"
                        disabled 
                    />
                    <label :for="`score-${important.id}`" :key="key+'-1'">{{important.title}}</label>
                </template>
            </div>
        </div>
 -->
        
        <div class="new_content_box2"> 
            <div class="review_evaluation_box" style="animation: opacity1 0.8s;">
                <h3 class="title">
                    <span>어떤 점이 좋았나요?</span>
                </h3>
                <div class="review_evaluation">
                    <template v-for="(important, key) in REVIEW_DETAIL_SCORE">
                        <input 
                            type="checkbox" 
                            :id="`detail-Score-${important.id}`" 
                            :value="important.id" 
                            :key="key" 
                            :checked="checkedDetailScore(important.id)"
                            disabled
                        />
                        <label :for="`detail-Score-${important.id}`" :key="key+'-1'">{{important.title}}</label>
                    </template>
                </div>

                <p>자세한 후기</p>
                <textarea 
                    class="reservation_textarea" 
                    :placeholder="checkedContent()"
                    v-model="review.content"
                    disabled
                ></textarea>
            </div>
        </div>
        
    </div>
</section>
</template>

<script>
import { mapGetters,mapState } from 'vuex';
import StarRating  from "vue-star-rating";
export default {
    name:'MyBookingReview',
    components: { 
        StarRating
    },
    data() {
        return {
            dtype: '',
            item: {},
            review: {
                dtype: '',
                score: '',
                rating: '',
                detailScore: [],
                content: '',
            }
        }
    },
    created() {
        this.$store.state.headerTitle = '후기 확인';
        this.dtype = this.TABLE_TYPE.SC.id;
        this.$store.dispatch('GET_BOOKING', this.bookingId)
        .then((data) => { 
            this.item = data;
            this.$store.commit('SHOW_ONLOAD');
        })
        .catch((e)=>{
            this.$store.commit('SHOW_ONLOAD');
            this.apiCatch(e);
        })
    },
    computed: {
        ...mapState({
            auth: state => state.auth.item,
            bookingItem: state => state.booking.item,
            reviewList: state => state.review.reviewList,

            TABLE_TYPE: state => state.codeDictionary.items.TABLE_TYPE,
            REVIEW_SCORE: state => state.codeDictionary.items.REVIEW_SCORE,
            REVIEW_SC_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SC_DETAIL_SCORE,
            REVIEW_SHOP_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SHOP_DETAIL_SCORE,
            REVIEW_TRIM_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_TRIM_DETAIL_SCORE,
        }),

        ...mapGetters([
            'viewScAttUrl',
            'viewShopAttUrl',
            'viewModelAttUrl',
        ]),

        bookingId() {
            return this.$route.params.bookingId;
        },

        routeName() {
            return this.$route.name;
        },

        REVIEW_DETAIL_SCORE(){
            if(this.dtype == this.TABLE_TYPE.SC.id) return this.REVIEW_SC_DETAIL_SCORE;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return this.REVIEW_SHOP_DETAIL_SCORE;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return this.REVIEW_TRIM_DETAIL_SCORE;
            return []
        },
        
        reviewTitle(){
            if(this.dtype == this.TABLE_TYPE.SC.id) return (this.bookingItem.sc) ? this.bookingItem.sc.name : '';
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return (this.bookingItem.sc) ? this.bookingItem.shop.name : '';
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return (this.bookingItem.sc) ? this.bookingItem.trim.name : '';
            return '';
        },

        reviewItem() 
        {
            if(this.dtype == this.TABLE_TYPE.SC.id) return this.bookingItem.reviewSc;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return  this.bookingItem.reviewShop;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return  this.bookingItem.reviewTrim;
            return null;
        },
        
        reviewImg(){
            if(this.dtype == this.TABLE_TYPE.SC.id) return this.viewScAttUrl( (this.bookingItem.scAtt) ? this.bookingItem.scAtt.url : null );
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return this.viewShopAttUrl((this.bookingItem.shopAtt) ? this.bookingItem.shopAtt.url : null);
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return this.viewModelAttUrl((this.bookingItem.modelAtt) ? this.bookingItem.modelAtt.url : null);
            return ''
        },

        reviewRating(){
            if(!Object.keys(this.bookingItem).length) return;
            if(this.dtype == this.TABLE_TYPE.SC.id) return this.bookingItem.reviewSc.rating;
            else if(this.dtype == this.TABLE_TYPE.SHOP.id) return this.bookingItem.reviewShop.rating;
            else if(this.dtype == this.TABLE_TYPE.TRIM.id) return this.bookingItem.reviewTrim.rating;
            return ''
        }

    },
    methods: {
        tab(tableType){
            this.dtype = tableType;
        },
        checkedScore(score) {
            return ( (this.reviewItem) && (this.reviewItem.score == score));
        },
        checkedDetailScore(detailScore) {
            return ( (this.reviewItem) && this.reviewItem.detailScore.includes(detailScore));
        },
        checkedContent() {
            return ( (this.reviewItem) ? this.reviewItem.content : '');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>